

    <mat-toolbar class="toolbar">
  <button matIconButton (click)="drawer.toggle()" class="example-icon" aria-label="Example icon-button with menu icon">
    <mat-icon>menu</mat-icon>
  </button>
  <span>Neska Bike Tracker</span>
  <span> - </span> 
  <span>{{userName}}</span>
  <span class="example-spacer"></span>
  <button matIconButton (click)="logout()" class="example-icon logout-icon" aria-label="Example icon-button with heart icon">
    <mat-icon>logout</mat-icon>
  </button>
  <button matIconButton class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
    <mat-icon>favorite</mat-icon>
  </button>
  <button matIconButton class="example-icon" aria-label="Example icon-button with share icon">
    <mat-icon>share</mat-icon>
  </button>
</mat-toolbar>


<mat-drawer-container class="example-container" autosize>
    
  <mat-drawer #drawer class="example-sidenav" mode="over">
    <p>Auto-resizing sidenav</p>
    @if (showFiller) {
      <p>Lorem, ipsum dolor sit amet consectetur.</p>
    }
    <button (click)="showFiller = !showFiller" matButton="elevated">
      Toggle extra text
    </button>

    <mat-tree #tree [dataSource]="dataSource" [childrenAccessor]="childrenAccessor">
  
        <!-- This is the tree node template for leaf nodes -->
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
    <!-- use a disabled button to provide padding for tree leaf -->
    <button matIconButton disabled></button>
    
    <button (click)="goToPath(node.click)" matButton="elevated">{{node.name}}</button>
    
  </mat-tree-node>
  
  <!-- This is the tree node template for expandable nodes -->
  <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodeToggle
                 [cdkTreeNodeTypeaheadLabel]="node.name">
    <button matIconButton matTreeNodeToggle
            [attr.aria-label]="'Toggle ' + node.name">
      <mat-icon class="mat-icon-rtl-mirror">
        {{tree.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
      </mat-icon>
    </button>
    <button matButton="elevated" disabled >{{node.name}}</button>
    
  </mat-tree-node>
</mat-tree>

  </mat-drawer>

  <div class="example-sidenav-content">
    <ng-template #dynamicContainer ></ng-template>
  </div>

</mat-drawer-container>